import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useRefreshOnVisibility } from "@/hooks/useRefreshOnVisibility";
import { useUser } from "@/hooks/useUser";

export default function DashboardLayout() {
  const { user, isLoading, isAuthenticated } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      import.meta.env.VITE_DISABLE_AUTH !== "true" &&
      !isLoading &&
      !isAuthenticated
    ) {
      window.location.href = "/account";
    }
  }, [isAuthenticated, isLoading, navigate, user]);

  useRefreshOnVisibility({
    thresholdMinutes: 60,
    onExpire: () => {
      window.location.reload();
    },
  });

  return (
    <>
      <Header />
      <main className="min-h-[calc(100vh-128px)]">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
